import React, { useEffect, useState } from 'react'
import useDestinations from '../../../../../hooks/useDestinations'
import { Button, Divider, Empty, Image, Popconfirm, Spin, Tag, notification } from 'antd'
import { useNavigate } from 'react-router-dom'
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

import './styles.scss'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { ATTRACTTIONS_CONTAINER, handleDeleteBlob } from '../../../../../azure/blob'
import useAttractions from '../../../../../hooks/useAttractions'
import { deleteAttraction, getAttractionById } from '../../../../../../redux/api/attractions.api'
import useMyProfile from '../../../../../hooks/useMyProfile';
import { ADMIN, SUPER_ADMIN } from '../../../../../Constants/roles';


const Attraction = () => {
    const destinations = useDestinations()
    const attractions = useAttractions().attractions
    const destinationNames = destinations.destinationNames
    const url = window.location.pathname
    const attractionId = url.split('/').pop()
    const [loading, setLoading] = useState(false)
    const [attraction, setAttraction] = useState()
    const navigate = useNavigate()
    const [api, contextHolder] = notification.useNotification();
    const [loadingText, setLoadingText] = useState('Please Wait...')
    const myProfile = useMyProfile().userProfile

    useEffect(() => {
        if (attractions?.length > 0) {
            const attraction = attractions.find(attraction => attraction.id === attractionId)
            if (attraction) {
                setAttraction(attraction)
            } else {
                handleGetDestination(attractionId)
            }
        } else {
            handleGetDestination(attractionId)
        }
    }, [])

    const handleGetDestination = async (id) => {
        setLoading(true)
        try {
            const destination = await getAttractionById(id)
            setAttraction(destination.data[0])
        } catch (error) {
            console.error('Error fetching destination', error)
        }
        setLoading(false)
    }

    const getBlobName = (blobUrl) => {
        const splitUrl = blobUrl.split('/')
        return splitUrl[splitUrl.length - 1]
    }

    const handleDeleteDestination = async () => {
        setLoading(true)
        try {
            // get all blobs
            let attractionImages = attraction.attractionImages?.split(',')
            let attractionVideos = attraction.attractionVideos?.split(',')
            let thumbnail = attraction.thumbnailUrl

            if (attractionImages?.length > 0) {
                setLoadingText('Deleting Attraction Images');
                const imageDeletePromises = attractionImages.map(async (image, index) => {
                    const blobName = getBlobName(image);
                    setLoadingText(`Deleting image ${index + 1}`);
                    return handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
                });
                await Promise.all(imageDeletePromises);
            }

            if (attractionVideos?.length > 0) {
                setLoadingText('Deleting Attraction Videos');
                const videoDeletePromises = attractionVideos.map(async (video, index) => {
                    const blobName = getBlobName(video);
                    setLoadingText(`Deleting video ${index + 1}`);
                    return handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
                });
                await Promise.all(videoDeletePromises);
            }

            if (thumbnail) {
                setLoadingText('Deleting Attraction Thumbnail');
                const blobName = getBlobName(thumbnail);
                setLoadingText(`Deleting thumbnail`);
                await handleDeleteBlob(ATTRACTTIONS_CONTAINER, blobName);
            }

            const res = await deleteAttraction(attractionId)

            if (res.status === 200) {
                api.success({
                    message: 'Attraction deleted successfully',
                    description: 'The attraction has been successfully deleted'
                })

                setTimeout(() => {
                    navigate('/dashboard/tours/attractions')
                }, 2000)

            } else {
                api.error({
                    message: 'Error deleting attraction',
                    description: 'An error occurred while deleting the attraction'
                })
            }

        } catch (error) {
            console.error('Error deleting attraction', error)
            api.error({
                message: 'Error deleting attraction',
                description: error.message
            })
        }
        setLoading(false)
    }

    return (
        <div className='destination'>
            {contextHolder}
            <Spin
                spinning={loading}
                size='large'
                tip={loadingText}
            >
                <>
                    <div className='destination__header'>
                        <h1>
                            {attraction?.attractionName}
                        </h1>
                        {(myProfile?.role === SUPER_ADMIN || myProfile?.role === ADMIN) &&
                            <div className='destination__header__actions'>
                                <Button type='primary' onClick={() => navigate(`/dashboard/tours/attractions/edit/${attractionId}`)} icon={<EditOutlined />}>
                                    Edit
                                </Button>
                                <Popconfirm
                                    title='Are you sure you want to delete this destination?'
                                    description={<p
                                        style={{
                                            width: '300px',
                                            color: 'red',
                                        }}
                                    >This action cannot be undone! This will permanently delete the attraction, its images, videos, attractions and other related items.</p>}
                                    onConfirm={handleDeleteDestination}
                                    okText='Yes'
                                    cancelText='No'
                                >
                                    <Button danger type='primary' icon={<DeleteOutlined />}>
                                        Delete
                                    </Button>
                                </Popconfirm>
                            </div>
                        }
                    </div>
                    <div className='destination__content_images'>
                        <div className='destination__content__image'>
                            <img src={attraction?.thumbnailUrl} alt='destination' />
                        </div>
                        <div className='destination__content__galery'>
                            <Image.PreviewGroup>
                                {attraction?.attractionImages?.split(',').map((image, index) => (
                                    <Image
                                        key={index}
                                        width={160}
                                        height={100}
                                        src={image}
                                        className='destination__content__galery__image'
                                    />
                                ))}
                            </Image.PreviewGroup>
                        </div>
                    </div>
                    <Divider />
                    <div className='destination__content_videos'>
                        <h2>Videos</h2>
                        <div className='destination__content__videos'>
                            {attraction?.attractionVideos ? <>
                                {attraction?.attractionVideos?.split(',').map((video, index) => (
                                    <video key={index} controls>
                                        <source src={video} type='video/mp4' />
                                    </video>
                                ))}
                            </>
                                :
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            }
                        </div>
                    </div>

                    <Divider />

                    <div className='destination__content_details'>
                        <h2>
                            Details
                        </h2>
                        <div className='destination__content__details'>
                            <div className='left'>
                                <p><strong>City: </strong>{attraction?.attractionCity || 'N/A'}</p>
                                <p><strong>Coordinates: </strong>{attraction?.attractionCoordinates || 'N/A'}</p>
                                <p><strong>Weather: </strong>{attraction?.weather || 'N/A'}</p>
                                <p><strong>Type: </strong>{attraction?.attractionType || 'N/A'}</p>
                            </div>
                            <div className='right'>
                                <p><strong>Destination: </strong>
                                    {destinationNames?.find(destination => destination.id === attraction?.destinationId)?.destinationName || 'N/A'}
                                </p>
                                <p><strong>Tags: </strong>
                                    {attraction?.tags?.split(',').map((tag, index) => (
                                        <Tag key={index}>{tag} </Tag>
                                    ))}
                                </p>
                                <p><strong>Ticket: </strong>{attraction?.ticketPrice || 'N/A'}</p>
                            </div>
                        </div>
                    </div>

                    <div className='destination__content_description'>
                        <h2>
                            Descriptions
                        </h2>
                        <h3>
                            Short Description
                        </h3>
                        <ReactQuill
                            value={attraction?.attractionDescriptionShort}
                            readOnly={true}
                            theme='bubble'
                        />

                        <h3>
                            Full Description
                        </h3>
                        <ReactQuill
                            value={attraction?.attractionDescription}
                            readOnly={true}
                            theme='bubble'
                        />


                        <h3>
                            Rules
                        </h3>
                        <ReactQuill
                            value={attraction?.rules}
                            readOnly={true}
                            theme='bubble'
                        />
                    </div>

                    <Divider />
                    <div className='destination__content_reviews'>
                        <h2>
                            Reviews
                        </h2>
                    </div>

                    <Divider />

                    <div className='destination__content_emergency'>
                        <h2>
                            Emergency Contacts
                        </h2>
                    </div>
                </>
            </Spin>
        </div>
    )
}

export default Attraction